import React from "react";
import useFilteredEvents, { Event } from "./useFilteredEvents";
import { DateType } from "./filters/DateTab";
import EventsList from "./EventsList";

const EventResults = ({
  keywords,
  date
}: {
  keywords: string | null;
  date: DateType | null;
}) => {
  const { error, loading, events } = useFilteredEvents(keywords, date);

  const renderNothing = keywords === null && date === null;

  if (renderNothing) return null;
  else return <EventsList loading={loading} events={events} />;
};
export default EventResults;
